import { useDisclosure } from '@ds';
import { CompareModal } from '@lp/features/MultiSuggest/components/CompareModal';
import { Case } from '@/api/apis/case';
import { useMultiSuggestionItemByChainQuery } from '@/queries/multi-suggest';
import { CaseInfo } from './CaseInfo';
import { LogisticsInfo } from './LogisticsInfo';
import { SuggestInfo } from './SuggestInfo';
import { CaseButtons } from './CaseButtons';

type CaseResultProps = {
  taskId: string;
  caseData: Case;
  chainNumber: number;
  isInitialCase?: boolean;
};

export const CaseResult = ({ taskId, caseData, chainNumber, isInitialCase }: CaseResultProps) => {
  const { data, isLoading, isPending } = useMultiSuggestionItemByChainQuery(taskId, chainNumber, caseData.caseId);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isCompareEnabled = !!data?.legs.size;

  return (
    <>
      <div className="flex flex-col rounded-2xl bg-white w-min">
        <CaseInfo caseData={caseData} isInitialCase={isInitialCase} />
        <LogisticsInfo serviceType={caseData.serviceType} />
        <SuggestInfo serviceType={caseData.serviceType} data={data} isLoading={isLoading || isPending} />
        <CaseButtons caseId={caseData.caseId} handleCompareModalOpen={onOpen} isCompareEnabled={isCompareEnabled} />
      </div>
      {isOpen && (
        <CompareModal
          taskId={taskId}
          chainNumber={chainNumber}
          caseData={caseData}
          isOpen={isOpen}
          onCloseModal={onClose}
        />
      )}
    </>
  );
};
